import React, { useEffect } from 'react';
import { EditProfilePageStyled } from './edit-profile.page.styled';
import Form from '../../../components/shared/form/form';
import { ValidationEditProfileSchema } from './components/edit-profile.page.constants';
import EditProfileForm from './components/edit-profile-form';
import i18n from '../../../translations/strings';
import { useDispatch, useSelector } from 'react-redux';
import { useModal } from '../../../components/shared/modal-provider/hooks/modal-provider.hook';
import {
  editProfileAction,
  editProfileResetState,
  retrieveUserDataAction,
} from '../../../store/customers/edit-profile.store';
import { ModalVariant } from '../../../components/shared/modal-provider/components/modal/modal.constants';

const EditProfilePage = () => {
  const { editProfileSuccess, loading, error } = useSelector((state: any) => {
    return state.editProfile;
  });

  const dispatch = useDispatch();
  const { openModal } = useModal();

  const onSubmit = (data: any) => {
    dispatch(editProfileAction(data));
  };

  useEffect(() => {
    if (editProfileSuccess) {
      openModal({
        message: i18n.t('editProfile.editProfileSuccess'),
        variant: ModalVariant.Success,
      });
      dispatch(retrieveUserDataAction());
      dispatch(editProfileResetState());
    }
  }, [editProfileSuccess]);

  useEffect(() => {
    if (error) {
      openModal({ message: error, variant: ModalVariant.Error });
      dispatch(editProfileResetState());
    }
  }, [error]);

  return (
    <EditProfilePageStyled.Container container>
      <EditProfilePageStyled.ContainerForm item md={5} xs={12}>
        <EditProfilePageStyled.TitlePage>
          {i18n.t('editProfile.titlePage')}
        </EditProfilePageStyled.TitlePage>
        <Form schema={ValidationEditProfileSchema}>
          <EditProfileForm onSubmit={onSubmit} loading={loading} />
        </Form>
      </EditProfilePageStyled.ContainerForm>
    </EditProfilePageStyled.Container>
  );
};

export default EditProfilePage;
